import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Trading from './pages/Trading';
import Blog from './pages/Blog';
import BlogPostDetail from './pages/BlogPostDetail';
import Reviews from './pages/Reviews';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import './App.css';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Scroll to top button component
function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="scroll-to-top-btn"
          aria-label="Scroll to top"
        >
          ↑
        </button>
      )}
    </>
  );
}

// Conditional Footer component
function ConditionalFooter() {
  const location = useLocation();
  const isAdminRoute = location.pathname === '/admin';
  
  return !isAdminRoute ? <Footer /> : null;
}

function App() {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);

  const handleAdminLogin = (success) => {
    setIsAdminAuthenticated(success);
  };

  const handleAdminLogout = () => {
    setIsAdminAuthenticated(false);
  };

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/trading" element={<Trading />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPostDetail />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route 
              path="/admin" 
              element={
                isAdminAuthenticated ? 
                <Admin onLogout={handleAdminLogout} /> : 
                <AdminLogin onLogin={handleAdminLogin} />
              } 
            />
          </Routes>
        </main>
        <ConditionalFooter />
        <ScrollToTopButton />
      </div>
    </Router>
  );
}

export default App; 